/**
 * Learn more about light and dark modes:
 * https://docs.expo.dev/guides/color-schemes/
 */

import { Colors } from '@/constants/Colors';

export function useColor() {
  // const theme = useColorScheme() ?? 'light';
  // Force Light until we support dark mode
  const theme = 'light';

  return Colors[theme];
}
